import React from 'react';
import PropTypes from 'prop-types';
import { valueOrPlaceholder } from 'helpers/string_helpers';
import PhoneList from '../phone_list';

export default class PersonBody extends React.Component {
  static propTypes = {
    crmEmail: PropTypes.string,
    record: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired
  }

  handleEmail = (e) => {
    e.preventDefault();
    const { crmEmail, record } = this.props;

    let url = `mailto:${record.email}`;
    if (crmEmail) {
      url += `?bcc=${encodeURIComponent(crmEmail)}`;
    }
    window.open(url);
  };

  render = () => {
    const { record, user } = this.props;

    return (
      <div className="preview-overlay-body">
        <div className="row">
          <div className="col-md-6">
            <div className="preview-title">Company</div>
            <div className="preview-text">
              {valueOrPlaceholder(record.companyName)}
            </div>
          </div>

          <div className="col-md-6">
            <div className="preview-title">Role</div>
            <div className="preview-text">
              {valueOrPlaceholder(record.jobTitle)}
            </div>
          </div>

          <div className="col-md-6">
            <div className="preview-title">Email</div>
            <div className="preview-text contact-link" onClick={this.handleEmail}>
              {valueOrPlaceholder(record.email)}
            </div>
          </div>

          <div className="col-md-12">
            <div className="preview-title">Phone</div>
            <div className="preview-text">
              <PhoneList name={record.name} phoneNumbers={record.phoneNumbers} user={user}/>
            </div>
          </div>

          <div className="col-md-12">
            <div className="preview-title">Notes</div>
            <div className="preview-text">
              {valueOrPlaceholder(record.personalNotes)}
            </div>
          </div>
        </div>
      </div>
    );
  };
}
